// The colour roles of src/index.css hold RGB triplets (`--accent-solid: 8 162 186`), so a bare `var(--accent-solid)` is not a colour:
// the `stroke` attribute keeps the variable (the contract of the icons), the inline style wraps it into rgb() so that it renders.
export function strokeStyle(color) {
  return /^var\(--[\w-]+\)$/.test(color) ? { stroke: `rgb(${color})` } : undefined;
}
